export { SearchA, setCollectionsByGames } from './SearchA';